import { ElementRef, Renderer2, EventEmitter } from '@angular/core';
var QuestionnaireGradeComponent = (function () {
    function QuestionnaireGradeComponent(el, renderer) {
        this.el = el;
        this.renderer = renderer;
        this.outPutLevel = new EventEmitter(); //回传打分等级
    }
    QuestionnaireGradeComponent.prototype.ngOnInit = function () {
        this.afterQuestionnaireScoreArray = this.questionnaireScoreArray.filter(function (d) { return d.level !== 0; });
    };
    QuestionnaireGradeComponent.prototype.ngAfterViewInit = function () {
    };
    // 打分
    QuestionnaireGradeComponent.prototype.giveMark = function (index) {
        for (var i = 0, len = this.afterQuestionnaireScoreArray.length; i < len; i += 1) {
            if (i <= index) {
                this.renderer.addClass(this.el.nativeElement.querySelector('.star-' + i), 'active');
            }
            else {
                this.renderer.removeClass(this.el.nativeElement.querySelector('.star-' + i), 'active');
            }
        }
        this.outPutLevel.emit(index);
    };
    return QuestionnaireGradeComponent;
}());
export { QuestionnaireGradeComponent };



// WEBPACK FOOTER //
// ./src/app/app-questionnaire/questionnaire-grade/questionnaire-grade.component.ts.pre-build-optimizer.js